import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

function CalculationItemOptions({ data }) {
  return (
    <>
      {data.length > 0 &&
        get(data, '0.type') === 'bpls_tax_revenue_calculation_options' && (
          <div className="px-1">
            <table className="table table-bordered table-stripped table-sm">
              <thead>
                <tr>
                  <th>LABEL</th>
                  <th>:</th>
                  <th>AMOUNT</th>
                </tr>
              </thead>
              <tbody>
                {data.map(detail => {
                  return (
                    <tr>
                      <td className="text-dark" width="150">
                        {get(detail, 'attributes.multiplier') || '-'}
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>{get(detail, 'attributes.amount_human') || '-'}</b>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
    </>
  );
}

CalculationItemOptions.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
};

export default CalculationItemOptions;
